import { useQuery } from '@tanstack/react-query';

import type { PodcastShow } from '~/services/api/subscription/getShows.server';

export const subscriberShowsKeys = {
  all: ['subscriber-shows'] as const,
  bySubscriber: (subscriberId: string) => ['subscriber-shows', subscriberId] as const,
};

const fetchSubscriberShows = async (): Promise<PodcastShow[]> => {
  const response = await fetch('/subscriber_shows');
  if (!response.ok) throw new Error('Failed to fetch subscriber shows');
  return response.json();
};

interface Props {
  enabled: boolean;
  subscriberId: string;
}

interface ReturnProps {
  isLoading: boolean;
  shows: PodcastShow[];
  refetch: () => void;
}

const useStaticShows = ({ enabled, subscriberId }: Props): ReturnProps => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: subscriberShowsKeys.bySubscriber(subscriberId),
    queryFn: fetchSubscriberShows,
    enabled: enabled && !!subscriberId,
    staleTime: Number.POSITIVE_INFINITY,
    refetchOnWindowFocus: false,
  });

  return {
    refetch,
    isLoading: isLoading && enabled,
    shows: data ?? [],
  };
};

export default useStaticShows;
